export default "__VITE_ASSET__rbOi5Bks__"